var _script, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClover = function SvgClover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 114 114",
    fill: "none"
  }, props), _script || (_script = /*#__PURE__*/React.createElement("script", {
    type: "text/javascript"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.64 0H27.36C12.25 0 0 12.25 0 27.36v59.28C0 101.751 12.25 114 27.36 114h59.28c15.111 0 27.36-12.249 27.36-27.36V27.36C114 12.25 101.751 0 86.64 0Z",
    fill: "url(#clover_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.999 93.48c20.147 0 36.48-16.332 36.48-36.48 0-20.147-16.333-36.48-36.48-36.48S20.519 36.853 20.519 57c0 20.148 16.333 36.48 36.48 36.48Zm-6.438-55.26c0-.294.239-.532.533-.532h11.809c.294 0 .533.238.533.533v12.477H50.562v12.604h12.874V75.78a.533.533 0 0 1-.533.533H51.094a.533.533 0 0 1-.533-.533V63.709h-12.34a.533.533 0 0 1-.534-.534V51.231c0-.294.239-.533.534-.533h12.341V38.221Zm12.875 12.478H75.78c.295 0 .534.239.534.533v11.944a.533.533 0 0 1-.534.534H63.438l-.002-13.01Z",
    fill: "#0C0B0B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "clover_svg__a",
    x1: 109.25,
    y1: 5.429,
    x2: -33.25,
    y2: 167.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDFDE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9BDAF6"
  })))));
};
export default SvgClover;